import Head from "next/head";
import Footer from "pages/components/Footer";
import Topbar from "pages/components/Topbar";
import React from "react";
import { ExtendedNextPage } from "types/pages";
import StartHummingVendor from "pages/components/StartHummingVendor";
import styles from "./styles.module.scss";
import Heading from "./components/Heading";
import JoinNow from "./components/JoinNow";
import WeAreLookingFor from "./components/WeAreLookingFor";
import HearFromOurProviders from "./components/HearFromOurProviders";

const Vendors: ExtendedNextPage = () => {
  return (
    <div className={styles.container}>
      <Head>
        <title>Vendors page</title>
        <meta name="vendors" content="Humming home's vendors page" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Heading />
      <WeAreLookingFor />
      <JoinNow />
      <HearFromOurProviders />
      <StartHummingVendor fillColor="primary2" />
    </div>
  );
};

Vendors.getLayout = (page) => {
  return (
    <div>
      <Topbar withHeader />
      {page}
      <Footer />
    </div>
  );
};

export default Vendors;
